<ng-container
  *ngIf="{
    loading: loading$ | async,
    commandLoading: commandLoading$ | async,
  } as vm"
>
  <div
    class="custom-progress-bar progressBar"
    *ngIf="vm.loading || vm.commandLoading"
    [ngClass]="{ 'command-loading': vm.commandLoading }"
  >
    <p-progressBar
      mode="indeterminate"
      [style]="{ height: '6px' }"
    ></p-progressBar></div
></ng-container>

<div class="layout-topbar" role="toolbar" id="toolbar">
  <div class="layout-topbar-left flex !justify-between">
    <div class="layout-topbar__controls items-center !flex">
      <a
        class="layout-menu-button"
        (click)="appMain.onMenuButtonClick($event)"
        (keyup.enter)="appMain.onMenuButtonClick($event)"
        aria-label="toggle sidebar"
        data-testid="toggle-sidebar"
        role="button"
        pRipple
      >
        <i class="pi pi-bars" aria-hidden="true"></i>
      </a>
      <a
        class="layout-topbar-logo whitespace-nowrap text-ellipsis overflow-hidden"
        [style.background-image]="'url(' + orgConfig?.LOGO_URL + ')'"
        routerLink="/"
      >
        <span class=""> {{ orgConfig.NAME | propertyTranslator }}</span>
      </a>
    </div>
    <div
      class="layout-topbar--mobile flex items-center justify-center flex-row-reverse"
      *ngIf="isMobileScreen"
    >
      <ng-container *ngIf="isLoggedIn$ | async; else signInTplMobile">
        <div class="layout-topbar-item" *ngIf="userInfo">
          <a
            (click)="appMain.onTopbarItemClick($event, 'profile')"
            (keyup.enter)="appMain.onTopbarItemClick($event, 'profile')"
            class="items-center layout-topbar-item__profile"
          >
            <p-avatar
              styleClass="!rounded-full"
              shape="circle"
              *ngIf="userInfo?.value.basic_info?.profile_picture; else avatar"
            >
              <img
                [src]="
                  userInfo?.value.basic_info?.profile_picture | getLink | async
                "
                [attr.alt]="
                  userInfo?.value.basic_info?.full_name | propertyTranslator
                "
              />
            </p-avatar>
            <ng-template #avatar>
              <p-avatar styleClass="!rounded-full" shape="circle">
                <img src="/assets/images/avatar.jpg" alt="no avatar" />
              </p-avatar>
            </ng-template>
          </a>
          <ng-container
            *ngTemplateOutlet="userMenu; context: { id: userInfo?.id }"
          ></ng-container>
        </div>
        <!-- Counter Notification -->
        <app-counter-widget-list
          [isMobileScreen]="true"
        ></app-counter-widget-list>
        <div
          class="layout-topbar-item notifications"
          *ngIf="(counterLoading$ | async) === false"
        >
          <a
            class="px-6 py-6 w-100 h-100 flex items-center cursor-pointer"
            (click)="
              appMain.onTopbarItemClick($event, 'notifications');
              toggleNotifications()
            "
            (keyup.enter)="
              appMain.onTopbarItemClick($event, 'notifications');
              toggleNotifications()
            "
            pRipple
          >
            <span class="p-overlay-badge layout-topbar-item__menuIcon">
              <i
                class="pi pi-bell !text-xl"
                [ngClass]="{ 'notification-badge--active': showNotification }"
              >
                <p-badge
                  data-testId="notification-count"
                  *ngIf="unreadCount$ | async as count"
                  [class.hidden]="count <= 0"
                  [title]="count"
                  [value]="count < 100 ? count.toString() : '99+'"
                  styleClass="p-badge-sm notification-badge"
                ></p-badge>
              </i>
            </span>
          </a>
          <div class="notification-menu" *ngIf="showNotification">
            <ng-container *ngTemplateOutlet="notification"></ng-container>
          </div>
        </div>
        <div
          class="layout-topbar-item"
          *ngIf="(counterLoading$ | async) === false"
        >
          <span
            (click)="
              appMain.onTopbarItemClick($event, 'search'); toggleSearch()
            "
            (keyup.enter)="appMain.onTopbarMobileButtonClick($event)"
            [class.color-primary]="showSearch"
            class="search-icon layout-topbar-item__menuIcon"
            datatest-id="user-search-toggle"
            ><i
              class="pi pi-search"
              [ngClass]="{ 'notification-badge--active': showSearch }"
            ></i>
          </span>
          <div class="search-menu" *ngIf="showSearch">
            <span
              class="search-menu__search-bar__exit"
              (click)="
                appMain.onTopbarItemClick($event, 'search'); toggleSearch()
              "
              (keyup.enter)="appMain.onTopbarMobileButtonClick($event)"
            >
              <i class="pi mr-2 pi-chevron-left"></i>
            </span>
            <ng-container *ngTemplateOutlet="search"></ng-container>
          </div>
        </div>
        <ng-container *ngIf="isOsosAIEnabled">
          <div class="layout-topbar-item">
            <span
              class="layout-topbar-item__menuIcon px-6 py-6"
              (click)="onTopbarAiButtonClick()"
              (keyup.enter)="onTopbarAiButtonClick()"
            >
              <img src="/assets/images/ai-icon.svg" alt="" class="w-4" />
            </span>
          </div>
        </ng-container>
      </ng-container>

      <ng-template #signInTplMobile>
        <button
          (click)="signIn()"
          (keyup.enter)="signIn()"
          datatest-id="user-sign-in-btn"
          pRipple
          class="p-button p-button-white p-button-outlined"
        >
          {{ "labels.signIn" | translate }}
        </button>
      </ng-template>
    </div>
  </div>
  <div class="flex items-center breadcrumb-overflow">
    <app-breadcrumb></app-breadcrumb>
  </div>
  <div
    class="layout-topbar-right"
    *ngIf="!isMobileScreen"
    [ngClass]="{ 'layout-topbar-mobile-active': appMain.mobileTopbarActive }"
  >
    <!-- <div class="layout-topbar-actions-left">&nbsp;&nbsp;</div> -->
    <div class="layout-topbar-actions-right">
      <ng-container *ngIf="isLoggedIn$ | async">
        <ul
          class="layout-topbar-items"
          *ngIf="(counterLoading$ | async) === false"
        >
          <ng-container *ngIf="isOsosAIEnabled">
            <li class="layout-topbar-item p-6">
              <span
                class="ai-icon"
                (click)="onTopbarAiButtonClick()"
                (keyup.enter)="onTopbarAiButtonClick()"
              >
                <img src="/assets/images/ai-icon.svg" alt="" class="w-4" />
              </span>
            </li>
          </ng-container>
          <li class="layout-topbar-item">
            <span
              (click)="
                appMain.onTopbarItemClick($event, 'search'); toggleSearch()
              "
              (keyup.enter)="appMain.onTopbarMobileButtonClick($event)"
              [class.color-primary]="showSearch"
              class="search-icon px-6 py-6 w-100 h-100 flex items-center cursor-pointer text-xl"
              ><i class="pi pi-search"></i>
            </span>
            <div class="search-menu" #searchMenu>
              <ng-container *ngTemplateOutlet="search"></ng-container>
            </div>
          </li>

          <li class="layout-topbar-item notifications">
            <a
              class="px-6 py-6 w-100 h-100 flex items-center cursor-pointer"
              (click)="
                appMain.onTopbarItemClick($event, 'notifications');
                toggleNotifications()
              "
              (keyup.enter)="
                appMain.onTopbarItemClick($event, 'notifications');
                toggleNotifications()
              "
              pRipple
            >
              <span class="p-overlay-badge">
                <i class="pi pi-bell !text-xl">
                  <p-badge
                    data-testId="notification-count"
                    *ngIf="unreadCount$ | async as count"
                    [class.hidden]="count <= 0"
                    [title]="count"
                    [value]="count < 100 ? count.toString() : '99+'"
                    styleClass="p-badge-sm notification-badge"
                  ></p-badge>
                </i>
              </span>
            </a>
            <div class="notification-menu" #notificationMenu>
              <ng-container *ngTemplateOutlet="notification"></ng-container>
            </div>
          </li>
        </ul>
        <!-- Counter Notification -->
        <app-counter-widget-list></app-counter-widget-list>
      </ng-container>
      <ul class="layout-topbar-items !mr-4">
        <ng-container *ngIf="isLoggedIn$ | async; else signInTpl">
          <li class="layout-topbar-item" *ngIf="userInfo">
            <a
              (click)="appMain.onTopbarItemClick($event, 'profile')"
              (keyup.enter)="appMain.onTopbarItemClick($event, 'profile')"
              class="layout-topbar-action flex p-dir-row items-center h-full"
            >
              <span
                *ngIf="!activeDelegation; else activeDelegationTopbarItem"
                class="flex items-center gap-2"
              >
                <div>
                  <img
                    class="b-circle"
                    [src]="
                      userInfo?.value.basic_info?.profile_picture
                        ? (userInfo?.value.basic_info.profile_picture
                          | getLink
                          | async)
                        : '/assets/images/avatar.jpg'
                    "
                    alt="main user info"
                    width="32"
                    height="32"
                  />
                </div>
                <div class="flex flex-col ml-2">
                  <span class="fw-500">
                    {{
                      userInfo?.value?.basic_info?.full_name
                        | propertyTranslator
                    }}
                  </span>

                  <small>
                    {{ userInfo?.value?.account_information.email_address }}
                  </small>
                </div>
              </span>

              <ng-template #activeDelegationTopbarItem>
                <div class="h-full flex items-start main-user-avatar">
                  <img
                    class="b-circle"
                    [src]="
                      userInfo?.value.basic_info?.profile_picture
                        ? (userInfo?.value.basic_info.profile_picture
                          | getLink
                          | async)
                        : '/assets/images/avatar.jpg'
                    "
                    alt="main user info"
                    width="32"
                    height="32"
                  />
                </div>
                <span class="">
                  <span class="fw-500">
                    {{
                      userInfo?.value.basic_info?.full_name | propertyTranslator
                    }}
                  </span>

                  <span class="flex lg:items-center justify-between gap-1">
                    <app-delegation-badge
                      [avatar]="
                        activeDelegation.delegator?._resolved?.mainPicture
                          | getLink
                          | async
                      "
                      [delegatee]="
                        activeDelegation.delegator._resolved.mainTitle
                          | propertyTranslator
                      "
                    />

                    <app-exit-delegation-button />
                  </span>
                </span>
              </ng-template>
            </a>
            <ng-container
              *ngTemplateOutlet="userMenu; context: { id: userInfo?.id }"
            ></ng-container>
          </li>
        </ng-container>
        <ng-template #signInTpl>
          <li class="layout-topbar-item">
            <a
              (click)="signIn()"
              (keyup.enter)="signIn()"
              datatest-id="user-sign-in-btn"
              pRipple
              class="layout-topbar-action flex p-dir-row items-center p-4"
            >
              {{ "labels.signIn" | translate }}
            </a>
          </li>
        </ng-template>
      </ul>
    </div>
  </div>
</div>

<ng-template #userMenu let-userId="id">
  <ul
    class="layout-topbar-action-panel p-shadow-6"
    [@topbarActionPanelAnimation]="'visible'"
    *ngIf="appMain.activeTopbarItem === 'profile'"
  >
    <li role="none">
      <a
        [routerLink]="'/user/profile'"
        class="layout-topbar-action-item"
        role="menuitem"
      >
        <div class="flex flex-row items-center">
          <i class="pi pi-cog px-2"></i>
          <span>{{ "labels.Profile" | translate }}</span>
        </div>
      </a>
    </li>
    <app-user-delegations />
    <li role="none">
      <a
        [routerLink]="'/welcome'"
        class="layout-topbar-action-item"
        role="menuitem"
      >
        <i class="pi pi-info-circle px-2"></i>
        {{ "labels.help" | translate }}
      </a>
    </li>
    <ng-container *ngIf="tourSupported$ | async">
      <li *appHasAdminLevelOf="accessRightLevels.ViewAccess" role="none">
        <a
          (click)="startTour()"
          (keyup.enter)="startTour()"
          class="layout-topbar-action-item"
          role="menuitem"
        >
          <i class="pi pi-send px-2"></i>
          {{ "labels.startTour" | translate }}
        </a>
      </li>
    </ng-container>

    <li role="none">
      <a
        (click)="signOut()"
        (keyup.enter)="signOut()"
        class="layout-topbar-action-item"
        role="menuitem"
      >
        <span class="text-danger">
          <i class="pi pi-power-off px-2 text-danger"></i>
          {{ "labels.signOut" | translate }}
        </span>
      </a>
    </li>
  </ul>
</ng-template>

<ng-template #search>
  <div
    class="layout-topbar-action-panel search-menu search-menu--overlay"
    *ngIf="showSearch"
  >
    <app-search-menu (clicked)="toggleSearch(false)"></app-search-menu>
  </div>
</ng-template>

<ng-template #notification>
  <div
    class="layout-topbar-action-panel notification-menu p-0"
    *ngIf="showNotification"
  >
    <app-notification-menu
      (notificationRedirect)="onClickNotification()"
    ></app-notification-menu>
  </div>
</ng-template>
<app-osos-ai [(configActive)]="showAISide"></app-osos-ai>
